import CircleCheckIcon from '@nv/images/design/circle-check-icon'
import XCircleIcon from '@nv/images/design/x-circle-icon'
import clsx from 'clsx'
import styles from './PasswordValidationTxt.module.scss'

export const PasswordValidationTxt = ({ text, isValid }) => {
  const Icon = () => (isValid ? <CircleCheckIcon className={styles['icon']} /> : <XCircleIcon className={styles['icon']} />)

  return (
    <div className={styles['container']}>
      <Icon />

      <span className={clsx(styles['text'], styles[isValid ? 'text--valid' : 'text--invalid'])} role='alert'>
        {text}
      </span>
    </div>
  )
}
